import AuthService from "../../utilities/services/auth.service";

import { CustomFeeReportWrapper } from "../../components";

export default function CustomFeeReportPage() {
  const organization = AuthService.getOrg()[0];

  return <CustomFeeReportWrapper organization={organization} />;
}
